import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Card } from "@mui/material";

const theme = createTheme();
export function EditUserForm(props) {
  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            px: 2,
            py: 4,
            boxShadow: "0 8px 40px -12px rgba(0,0,0,0.4)",
            "&:hover": {
              boxShadow: "0 16px 55px -12.125px rgba(0,0,0,0.4)",
            },
            my: 5,
          }}
        >
          <Typography component="h1" variant="h5">
            Edit User
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={props.handleSubmit}
            sx={{
              mt: 3,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  autoComplete="user-name"
                  name="username"
                  required
                  fullWidth
                  id="username"
                  label="Username"
                  autoFocus
                  error={props.errors.userID && true}
                  helperText={
                    props.errors.userID !== "" ? props.errors.userID : " "
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  error={props.errors.email && true}
                  helperText={
                    props.errors.email !== "" ? props.errors.email : " "
                  }
                />
              </Grid>{" "}
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="given-name"
                  name="firstName"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  autoFocus
                  error={props.errors.firstName && true}
                  helperText={
                    props.errors.firstName !== "" ? props.errors.firstName : " "
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  autoComplete="family-name"
                  error={props.errors.lastName && true}
                  helperText={
                    props.errors.lastName !== "" ? props.errors.lastName : " "
                  }
                />
              </Grid>
              {/* Organization Select */}
              <Grid item sm={12}>
                <FormControl
                  fullWidth
                  sx={{
                    minWidth: "270px",
                  }}
                  error={props.errors.organization && true}
                >
                  <InputLabel
                    id="demo-simple-select-label"
                    error={props.errors && props.errors.organization && true}
                  >
                    Organization
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.organization}
                    label="Department"
                    onChange={props.handleChangeOrganization}
                    error={props.errors && props.errors.organization && true}
                    MenuProps={{ PaperProps: { sx: { maxHeight: "15%" } } }}
                  >
                    {props.organizationsList.map((organization, index) => {
                      return (
                        <MenuItem value={organization.name} key={index}>
                          {organization.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText>
                    {props.errors.organization !== ""
                      ? props.errors.organization
                      : " "}
                  </FormHelperText>
                </FormControl>
              </Grid>
              {/* Department Select */}
              <Grid item sm={12}>
                <FormControl
                  fullWidth
                  sx={{
                    minWidth: "270px",
                  }}
                  error={props.errors.role && true}
                >
                  <InputLabel
                    id="demo-simple-select-label"
                    error={props.errors && props.errors.department && true}
                  >
                    Department
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.department}
                    label="Department"
                    onChange={props.handleChangeDepartment}
                    error={props.errors && props.errors.department && true}
                    MenuProps={{ PaperProps: { sx: { maxHeight: "15%" } } }}
                  >
                    {props.departmentsList.map((department, index) => {
                      return (
                        <MenuItem value={department} key={index}>
                          {department}
                        </MenuItem>
                      );
                    })}
                    <MenuItem value="admin">Admin</MenuItem>
                    <MenuItem value="procurement">Procurement</MenuItem>
                    <MenuItem value="sampleControl">Sample Control</MenuItem>
                    <MenuItem value="svp">SVP</MenuItem>
                  </Select>
                  <FormHelperText>
                    {props.errors.department !== ""
                      ? props.errors.department
                      : " "}
                  </FormHelperText>
                </FormControl>
              </Grid>
              {/* <Grid item sm={12}>
                <FormControl
                  fullWidth
                  sx={{
                    minWidth: "270px",
                  }}
                  error={props.errors.role && true}
                >
                  <InputLabel
                    id="demo-simple-select-label"
                    error={props.errors && props.errors.department && true}
                  >
                    Department
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.department}
                    label="Department"
                    onChange={props.handleChangeDepartment}
                    error={props.errors && props.errors.department && true}
                    MenuProps={{ PaperProps: { sx: { maxHeight: "15%" } } }}
                  >
                    {listOfDepartments.map((department, index) => {
                      return (
                        <MenuItem value={department} key={index}>
                          {department}
                        </MenuItem>
                      );
                    })}

                    <MenuItem value="procurement">Procurement</MenuItem>
                    <MenuItem value="sampleControl">Sample Control</MenuItem>
                    <MenuItem value="svp">SVP</MenuItem>
                    <MenuItem value="admin">Admin</MenuItem>
                  </Select>
                  <FormHelperText>
                    {props.errors.department !== ""
                      ? props.errors.department
                      : " "}
                  </FormHelperText>
                </FormControl>
              </Grid> */}
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                  error={props.errors.password && true}
                  helperText={
                    props.errors.password !== "" ? props.errors.password : " "
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password2"
                  label="Re-Enter Password"
                  type="password"
                  id="password2"
                  autoComplete="new-password-2"
                  error={props.errors.password2 && true}
                  helperText={
                    props.errors.password2 !== "" ? props.errors.password2 : " "
                  }
                />
              </Grid>
              <Grid item sm={12}>
                <FormControl
                  fullWidth
                  sx={{
                    minWidth: "270px",
                  }}
                  error={props.errors.role && true}
                >
                  <InputLabel
                    id="demo-simple-select-label"
                    error={props.errors && props.errors.role && true}
                  >
                    Role
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.role}
                    label="Role"
                    onChange={props.handleChangeRole}
                    error={props.errors && props.errors.role && true}
                    MenuProps={{ PaperProps: { sx: { maxHeight: "15%" } } }}
                  >
                    <MenuItem value="chef">Chef</MenuItem>
                    <MenuItem value="executiveChef">Executive Chef</MenuItem>
                    <MenuItem value="admin">Admin</MenuItem>
                    <MenuItem value="hod">HOD</MenuItem>
                    <MenuItem value="procurement">Procurement</MenuItem>
                    <MenuItem value="sampleControl">
                      Sample Control Team
                    </MenuItem>
                    <MenuItem value="sampleControlView">
                      Sample Control Team - (View Only)
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {props.errors.role !== "" ? props.errors.role : " "}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
              }}
            >
              Submit
            </Button>
          </Box>
        </Card>
      </Container>
    </ThemeProvider>
  );
}
